export function audienceConfirmRows(audiences, resolveDetail) {
  return audiences.map(audience => ({
    name: audience.attributes.audience_name,
    count: resolveDetail(audience)?.attributes.number_of_contacts ?? 0
  }))
}
